export enum lockerActionTypes {
  UPDATE_IS_AGENT_PROCESS = 'update_is_agent_process',
  UPDATE_CURRENT_LOCKER_POSITION = 'update_current_locker_position',
  UPDATE_CURRENT_PACKAGE_CANDIDATE = 'update_current_package_candidate',
  UPDATE_REMOVE_LOCKER_LIST = 'update_remove_locker_list',
  UPDATE_EMPLOYEE_NUMBER = 'update_employee_number',
  UPDATE_IS_MULTIDELIVERY = 'update_is_multidelivery',
  UPDATE_LOCKER_RACK_ID = 'update_locker_rack_id',
  UPDATE_LOCKER_CONTENT = 'update_locker_content',
  UPDATE_CUSTOMER_NAME = 'update_customer_name',
  UPDATE_CUSTOMER_SIGNATURE = 'update_customer_signature',
  LOCKER_RESET = 'locker_reset',
}
